export default {
  headers: [
    ['satellite-tracking/report.driver_name', 'driver'],
    ['satellite-tracking/report.vehicle_name', 'vehicle'],
    ['satellite-tracking/report.date', 'date'],
    ['satellite-tracking/report.duration', 'duration'],
    ['satellite-tracking/report.distance', 'distance'],
    ['satellite-tracking/report.spent_fuel', 'spentFuel']
  ]
}
